var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{attrs:{"id":"gjs"}}),_c('div',{staticClass:"side-bar",staticStyle:{"width":"100%"},attrs:{"id":"blocks"}})])
}]

export { render, staticRenderFns }